<ng-template
  let-extraClass="extraClass"
  #topNav
>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Dashboard'">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper *ngIf="loaded" [hasBottomNav]="true">
    <tidy-error-message *ngIf="errorMessage" [text]="errorMessage"></tidy-error-message>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <ng-container *ngIf="isLimitedAccount">
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Please contact your team leader for questions regarding jobs or payments.'">
        </tidy-text>
      </tidy-row>
      <tidy-card>
        <tidy-card-button class="arrow-to-top" (action)="goToCleaningsPage()">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/calendar.svg'"
              class="header-size">
            </tidy-image>
            <tidy-text
              [header]="'Next Job'">
            </tidy-text>
          </tidy-row>
          <tidy-row>
            <tidy-text
              *ngIf="dashboardData?.nextJob !== ''"
              [body]="dashboardData?.nextJob">
            </tidy-text>
            <tidy-text
              *ngIf="dashboardData?.nextJob === ''"
              [body]="'None Scheduled'">
            </tidy-text>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
      <tidy-row>
        <tidy-text
          [header]="'Requests'">
        </tidy-text>
      </tidy-row>
      <tidy-alert *ngIf="invitationsReceived?.length == 0 && delegationRequests?.length == 0">
        <tidy-text
          [body]="'No requests'">
        </tidy-text>
      </tidy-alert>
      <tidy-card *ngFor="let delegation of delegationRequests">
        <tidy-card-button (action)="goToDelegationRequest(delegation)">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/alert-circle.svg'"
              class="header-size">
            </tidy-image>
            <tidy-text
              [header]="(delegation.delegated_by_team_member.homekeeper.name | firstName) + (' asked you to accept a job' | translate)">
            </tidy-text>
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="('Any questions? Contact ' | translate) + (delegation.delegated_by_team_member.homekeeper.name | firstName) + '.'">
            </tidy-text>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
    </ng-container>

    <tidy-alert *ngFor="let invite of invitationsReceived">
      <ng-container *ngIf="invite?.job_delegation_request">
        <tidy-row class="vertical-align-center extra-bottom-padding">
          <tidy-image
            [src]="'assets/svg/alert-circle.svg'"
            class="header-size">
          </tidy-image>
          <tidy-text
            [header]="'Job Delegation Request'">
          </tidy-text>
        </tidy-row>
        <tidy-row class="vertical-align-center">
         <tidy-image
            [src]="'assets/svg/calendar-outline.svg'">
          </tidy-image>
          <tidy-text
            [body]="(invite?.job_delegation_request?.job?.friendly_date | formatDateTimePipe: 'MMM d':undefined:'MM/dd/yy') + (' at ' | translate) + invite?.job_delegation_request?.job?.friendly_start_time"
            [translate]="false">
          </tidy-text>
        </tidy-row>
        <tidy-row class="vertical-align-center extra-bottom-padding">
         <tidy-image
            [src]="'assets/svg/time-outline.svg'">
          </tidy-image>
          <tidy-text
            [body]="invite?.job_delegation_request?.job?.duration_in_hours + (' hour job' | translate)"
            [translate]="false">
          </tidy-text>
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="invite?.job_delegation_request?.delegator_name"
            [translate]="false">
          </tidy-text>
          <tidy-text
            [body]="' invited you to join their team and accept this job.
            If you accept, you will be expected to complete the job.
            Contact '">
          </tidy-text>
          <tidy-text
            [body]="invite?.job_delegation_request?.delegator_name"
            [translate]="false">
          </tidy-text>
          <tidy-text
            [body]="' for any questions.'">
          </tidy-text>
        </tidy-row>
      </ng-container>
      <ng-container *ngIf="!invite?.job_delegation_request">
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/people.svg'"
            class="header-size">
          </tidy-image>
          <tidy-text
            [header]="'Team Invite Pending'">
          </tidy-text>
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="invite?.team?.owner?.name"
            [translate]="false">
          </tidy-text>
          <tidy-text
            [body]="' invited you to their team. By joining, you agree that you are a subcontractor or employee of '">
          </tidy-text>
          <tidy-text
            [body]="invite?.team?.owner?.name">
          </tidy-text>
          <tidy-text
            [body]="'\'s business, and they are responsible for safety, legal, insurance, and employment obligations as well as the '">
          </tidy-text>
          <tidy-text
            [body]="'Service Provider Customer Agreement'"
            (action)="goToServiceProviderAgreement()"
            class="link">
          </tidy-text>
          <tidy-text
            [body]="'.'">
          </tidy-text>
        </tidy-row>
      </ng-container>
      <tidy-row class="extra-bottom-padding">
        <tidy-button
          [action]="acceptTeamInvite.bind(this, invite)"
          [text]="invite?.job_delegation_request ? 'Accept Job & Join Team' : 'Accept Invite'"
          class="primary">
        </tidy-button>
      </tidy-row>
      <tidy-row [align]="'center'">
        <tidy-text
          (action)="rejectTeamInvite(invite)"
          [body]="invite?.job_delegation_request ? 'Reject Job & Team Invite' : 'Reject Invite'"
          class="link">
        </tidy-text>
      </tidy-row>
    </tidy-alert>

    <ng-container *ngFor="let alert of alerts">
      <tidy-alert>
        <tidy-row class="vertical-align-center">
          <tidy-text
            class="red"
            [header]="alert?.title">
          </tidy-text>
        </tidy-row>
        <tidy-row>
          <tidy-text
            style="margin-right: 5px"
            [body]="alert?.body">
          </tidy-text>
          <tidy-text
            (action)="goToAlertPage(alert?.link)"
            [body]="alert?.link_text || 'More'"
            class="link">
          </tidy-text>
        </tidy-row>
      </tidy-alert>
    </ng-container>
    
    <tidy-alert *ngIf="requiresDirectDeposit && !isLimitedAccount">
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/icon/alert-circle-red.svg'"
          class="red header-size">
        </tidy-image>
        <tidy-text
          class="red"
          [header]="'Set Up Direct Deposit'">
        </tidy-text>
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'Please set up direct deposit to receive payments for your jobs.'">
        </tidy-text>
      </tidy-row>
      <tidy-row>
        <tidy-text
          (action)="goToPayoutSettingsPage()"
          [body]="'Set Up Now'"
          class="link">
        </tidy-text>
      </tidy-row>
    </tidy-alert>

    <ng-container *ngIf="wasInvitedByClient">
      <tidy-card *ngIf="!(certifications?.steps?.profile === 'complete' && jobNotificationSettings?.length > 0)">
        <tidy-row>
          <tidy-text [header]="'Get Started Now'"></tidy-text>
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="(clients[0]?.account_name !== '' && clients[0]?.account_name) ?
            clients[0]?.account_name :
            clients[0]?.first_name + ' ' + clients[0]?.last_name"
            [translate]="false">
          </tidy-text><span>&nbsp;</span>
          <tidy-text [body]="'uses TIDY to manage jobs. Please complete the following steps:'"></tidy-text>
        </tidy-row>
        <tidy-card-button (action)="goToJobNotificationSettingsPage()" [hideArrow]="jobNotificationSettings?.length > 0">
          <tidy-row class="vertical-align-center">
            <tidy-image [src]="jobNotificationSettings?.length > 0 ? 'assets/svg/checkmark-circle.svg' : 'assets/svg/square-outline.svg'" class="body-size"></tidy-image>
            <tidy-text [body]="'Add Job Notification Settings'"></tidy-text>
          </tidy-row>
        </tidy-card-button>
        <tidy-card-button (action)="goToAddAddressPage()" [hideArrow]="certifications?.steps?.profile === 'complete'">
          <tidy-row class="vertical-align-center">
            <tidy-image [src]="certifications?.steps?.profile === 'complete' ? 'assets/svg/checkmark-circle.svg' : 'assets/svg/square-outline.svg'" class="body-size"></tidy-image>
            <tidy-text [body]="'Add Address'"></tidy-text>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
      <tidy-card item-right data-cy="card-next-job">
        <tidy-card-button class="arrow-to-top" (action)="goToCleaningsPage()">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/calendar.svg'"
              class="header-size">
            </tidy-image>
            <tidy-text
              [header]="'Next Job'">
            </tidy-text>
          </tidy-row>
          <tidy-row class="no-padding">
            <tidy-text
              *ngIf="dashboardData?.nextJob !== ''"
              [body]="dashboardData?.nextJob">
            </tidy-text>
            <tidy-text
              *ngIf="dashboardData?.nextJob === ''"
              [body]="'None Scheduled'">
            </tidy-text>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
      <tidy-card data-cy="card-job-opportunities" item-right>
        <tidy-card-button (action)="goToAddPage()">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/add-circle.svg'"
              class="header-size">
            </tidy-image>
            <tidy-text
              [header]="'Job Requests'">
            </tidy-text>
          </tidy-row>
          <tidy-row class="no-padding">
            <tidy-text
              [body]="dashboardData?.jobOpportunities">
            </tidy-text>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
      <tidy-two-column-row>
        <tidy-card item-left data-cy="card-next-pay">
          <tidy-card-button class="arrow-to-top" (action)="goToEstimatedNextPaymentPage(dashboardData?.nextPay?.amount)">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/card.svg'"
                class="header-size">
              </tidy-image>
              <tidy-text
                [header]="'Balance'">
              </tidy-text>
            </tidy-row>
            <tidy-row class="vertical-align-center">
              <tidy-text
                *ngIf="dashboardData?.nextPay?.amount === '$0'"
                [body]="'$0 '">
              </tidy-text>
              <tidy-text
                *ngIf="dashboardData?.nextPay?.amount !== '$0'"
                [body]="'~' + dashboardData?.nextPay?.formatedNextPay">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-card item-left>
          <tidy-card-button (action)="goToQuestsPage()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                src="assets/img/quest-mountain-fill.svg"
                class="header-size">
              </tidy-image>
              <tidy-text
                [header]="'Quests'">
              </tidy-text>
            </tidy-row>
            <tidy-row class="no-padding">
              <tidy-text
                [body]="availableQuestCount">
              </tidy-text>
              <tidy-text
                [body]="' Available'">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      </tidy-two-column-row>
      <tidy-two-column-row>
        <tidy-card item-left>
          <tidy-card-button (action)="goToProposalsPage()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/proposals-white.svg'"
                class="body-size">
              </tidy-image>
              <tidy-text
                [header]="'Proposals'">
              </tidy-text>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="pendingProposalsCount">
              </tidy-text>
              <tidy-text
                [body]="' Pending'"
                class="margin-right-5">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-card item-right>
          <tidy-card-button (action)="goToUnpaidJobsPage()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/documents.svg'"
                class="header-size">
              </tidy-image>
              <tidy-text
                [header]="'Invoices'">
              </tidy-text>
            </tidy-row>
            <tidy-row>
              <ion-skeleton-text *ngIf="!unpaidJobs" animated style="width: 50%"></ion-skeleton-text>
              <tidy-text *ngIf="unpaidJobs !== undefined"
                [body]="unpaidJobs?.length">
              </tidy-text>
              <tidy-text *ngIf="unpaidJobs !== undefined"
                [body]="' Unpaid Jobs'"
                class="margin-right-5">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      </tidy-two-column-row>
    </ng-container>

    <ng-container *ngIf="!wasInvitedByClient">
      <tidy-card *ngIf="certifications?.all_steps_except_go_live">
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/checkmark-circle.svg'"
            class="header-size">
          </tidy-image>
          <tidy-text
            [header]="'You\'re Ready for Clients!'"
            class="green">
          </tidy-text>
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'You\'re ready to get job requests!'">
          </tidy-text>
        </tidy-row>
        <tidy-button
          [text]="'Turn on Job Requests'"
          [action]="goLive.bind(this)"
          class="primary">
        </tidy-button>
      </tidy-card>

      <tidy-alert *ngIf="hkCertificationStatus === 'inactive'">
        <tidy-row class="vertical-align-center">
          <tidy-image
            class="red"
            [src]="'assets/icon/alert-circle-red.svg'"
            class="header-size">
          </tidy-image>
          <tidy-text
            class="red"
            [header]="'Reliability Certification No Longer Valid'">
          </tidy-text>
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'You are unable to get job requests.  Tap here to re-request Reliability Certification.'">
          </tidy-text>
        </tidy-row>
        <tidy-row>
          <tidy-text
            (action)="goToReapplyPage()"
            [body]="'Request Certification'"
            class="link">
          </tidy-text>
        </tidy-row>
      </tidy-alert>

      <tidy-alert *ngIf="hkNotAvailableRepeat && hkCertificationStatus !== 'inactive'">
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/icon/alert-circle-red.svg'"
            class="red header-size">
          </tidy-image>
          <tidy-text
            class="red"
            [header]="'Not Available for Repeat Clients'">
          </tidy-text>
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'Open up recurring availability if you want repeat Clients. '">
          </tidy-text>
          <tidy-text
            (action)="goToMySchedule()"
            [body]="'View My Availability'"
            class="link">
          </tidy-text>
        </tidy-row>
      </tidy-alert>

      <tidy-card *ngIf="!certifications?.existing_clients && didFinishPaymentOnboarding">
        <tidy-card-button (action)="goToUnpaidJobsPage()">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/documents.svg'"
              class="header-size">
            </tidy-image>
            <tidy-text
              [header]="'Invoices'">
            </tidy-text>
          </tidy-row>
          <tidy-row>
            <ion-skeleton-text *ngIf="!unpaidJobs" animated style="width: 50%"></ion-skeleton-text>
            <tidy-text *ngIf="unpaidJobs !== undefined"
              [body]="unpaidJobs?.length">
            </tidy-text>
            <tidy-text *ngIf="unpaidJobs !== undefined"
              [body]="' Unpaid Jobs'"
              class="margin-right-5">
            </tidy-text>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>

      <tidy-card *ngIf="!isLimitedAccount" item-right data-cy="card-next-job">
        <tidy-card-button class="arrow-to-top" (action)="goToCleaningsPage()">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/calendar.svg'"
              class="header-size">
            </tidy-image>
            <tidy-text
              [header]="'Next Job'">
            </tidy-text>
          </tidy-row>
          <tidy-row class="no-padding">
            <tidy-text
              *ngIf="dashboardData?.nextJob !== ''"
              [body]="dashboardData?.nextJob">
            </tidy-text>
            <tidy-text
              *ngIf="dashboardData?.nextJob === ''"
              [body]="'None Scheduled'">
            </tidy-text>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>

      <tidy-card *ngIf="!isLimitedAccount" data-cy="card-job-opportunities" item-right>
        <tidy-card-button (action)="goToAddPage()">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/add-circle.svg'"
              class="header-size">
            </tidy-image>
            <tidy-text
              [header]="'Job Requests'">
            </tidy-text>
          </tidy-row>
          <tidy-row class="no-padding">
            <tidy-text
              [body]="dashboardData?.jobOpportunities">
            </tidy-text>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>

      <tidy-two-column-row *ngIf="certifications?.existing_clients">
        <tidy-card item-left data-cy="card-next-pay">
          <tidy-card-button class="arrow-to-top" (action)="goToEstimatedNextPaymentPage(dashboardData?.nextPay?.amount)">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/card.svg'"
                class="header-size">
              </tidy-image>
              <tidy-text
                [header]="'Balance'">
              </tidy-text>
            </tidy-row>
            <tidy-row class="vertical-align-center no-padding">
              <tidy-text
                *ngIf="dashboardData?.nextPay?.amount === '$0'"
                [body]="'$0 '">
              </tidy-text>
              <tidy-text
                class="link"
                *ngIf="dashboardData?.nextPay?.amount === '$0'"
                [body]="'Start Earning'"
                (action)="goToEstimatedNextPaymentPage(dashboardData?.nextPay?.amount)">
              </tidy-text>
              <tidy-text
                *ngIf="dashboardData?.nextPay?.amount !== '$0'"
                [body]="'~' + dashboardData?.nextPay?.formatedNextPay">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-card item-left>
          <tidy-card-button (action)="goToQuestsPage()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                src="assets/img/quest-mountain-fill.svg"
                class="header-size">
              </tidy-image>
              <tidy-text
                [header]="'Quests'">
              </tidy-text>
            </tidy-row>
            <tidy-row class="no-padding">
              <tidy-text
                [body]="availableQuestCount">
              </tidy-text>
              <tidy-text
                [body]="' Available'">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      </tidy-two-column-row>

      <tidy-two-column-row *ngIf="certifications?.existing_clients">
        <tidy-card item-left>
          <tidy-card-button (action)="goToProposalsPage()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/proposals-white.svg'"
                class="body-size">
              </tidy-image>
              <tidy-text
                [header]="'Proposals'">
              </tidy-text>
            </tidy-row>
            <tidy-row class="no-padding">
              <tidy-text
                [body]="pendingProposalsCount">
              </tidy-text>
              <tidy-text
                [body]="' Pending'"
                class="margin-right-5">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-card item-right>
          <tidy-card-button (action)="goToUnpaidJobsPage()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/documents.svg'"
                class="header-size">
              </tidy-image>
              <tidy-text
                [header]="'Invoices'">
              </tidy-text>
            </tidy-row>
            <tidy-row class="no-padding">
              <ion-skeleton-text *ngIf="!unpaidJobs" animated style="width: 50%"></ion-skeleton-text>
              <tidy-text *ngIf="unpaidJobs !== undefined"
                [body]="unpaidJobs?.length">
              </tidy-text>
              <tidy-text *ngIf="unpaidJobs !== undefined"
                [body]="' Unpaid Jobs'"
                class="margin-right-5">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      </tidy-two-column-row>

      <tidy-card data-cy="card-scores" *ngIf="certifications?.steps?.go_live === 'complete' && dashboardData?.qualityScore">
        <tidy-card-button class="arrow-to-top" (action)="goToFeedbackPage()">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/bar-chart.svg'"
              class="header-size">
            </tidy-image>
            <tidy-text
              [header]="'Scores'">
            </tidy-text>
          </tidy-row>
          <tidy-row class="no-padding">
            <tidy-grid class="vertical-align" >
              <ion-row>
                <ion-col size="5">
                  <tidy-text
                    [body]="'Quality'">
                  </tidy-text>
                </ion-col>
                <ion-col size="7">
                  <tidy-bar
                    [value]="dashboardData?.qualityScore">
                  </tidy-bar>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="5">
                  <tidy-text
                    [body]="'Reliability'">
                  </tidy-text>
                </ion-col>
                <ion-col size="7">
                  <tidy-bar
                    [value]="dashboardData?.reliabilityScore">
                  </tidy-bar>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="5">
                  <tidy-text
                    [body]="'Bookability'">
                  </tidy-text>
                </ion-col>
                <ion-col size="7">
                  <tidy-bar
                    [value]="dashboardData?.bookabilityScore">
                  </tidy-bar>
                </ion-col>
              </ion-row>
            </tidy-grid>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>


      <ng-container *ngIf="certifications?.steps?.go_live !== 'complete' && !isLimitedAccount">
        <tidy-row>
          <tidy-text
            [header]="'Get Started Now'">
          </tidy-text>
        </tidy-row>
        <tidy-card *ngIf="!certifications?.existing_clients">
          <tidy-card-button (action)="goToCertificationPage('existing-clients')">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/style-guide-images/private-client-white.svg'"
                class="header-size">
              </tidy-image>
              <tidy-text
                [header]="'Manage Existing Clients'">
              </tidy-text>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Book jobs, track mileage & more!'">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-card>
          <tidy-card-button (action)="goToCertificationPage('new-clients')">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/people-circle-outline.svg'"
                class="header-size">
              </tidy-image>
              <tidy-text
                [header]="'Get New Clients'">
              </tidy-text>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Clients in your area are looking for Pros!'">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-card *ngIf="!didFinishPaymentOnboarding">
          <tidy-card-button (action)="goToReceivePaymentsFromClientsPage()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/cash.svg'"
                class="header-size">
              </tidy-image>
              <tidy-text
                [header]="'Receive Payments from Clients'">
              </tidy-text>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'TIDY makes it easier to earn more.'">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!isLimitedAccount">
      <tidy-row [alignLastItemRight]="true">
        <tidy-text
          [header]="'Notifications'">
        </tidy-text>
        <div class="notification-actions">
          <mat-icon
            (click)="goToNotificationSettings()">
            settings
          </mat-icon>
        </div>
      </tidy-row>

      <tidy-error-message
        [text]="updateError">
      </tidy-error-message>

      <notification-list
        [filteredNotifications]="filteredNotifications"
        [totalNotifications]="totalNotifications"
        [loaded]="loaded"
        [showExamples]="showExamples"
        [showKeys]="showKeys"
        [examples]="examples"
        [errorMessage]="errorMessage"
        (loadMore)="loadMoreNotifications($event)"
        (notificationClick)="goToNotificationPage($event)"
        (toggleKeys)="showKeys = $event">
      </notification-list>
    </ng-container>

  </tidy-wrapper>

  <tidy-wrapper *ngIf="!loaded">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <!-- Next Job skeleton -->
    <tidy-card>
      <tidy-card-button [hideArrow]="true">
        <tidy-row class="vertical-align-center">
          <ion-skeleton-text animated style="width: 18px; height: 18px; border-radius: 4px; margin-right: 5px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
        </tidy-row>
        <tidy-row>
          <ion-skeleton-text animated style="width: 55%"></ion-skeleton-text>
        </tidy-row>
      </tidy-card-button>
    </tidy-card>

    <!-- Job Requests skeleton -->
    <tidy-card>
      <tidy-card-button [hideArrow]="true">
        <tidy-row class="vertical-align-center">
          <ion-skeleton-text animated style="width: 18px; height: 18px; border-radius: 4px; margin-right: 5px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 35%"></ion-skeleton-text>
        </tidy-row>
        <tidy-row>
          <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
        </tidy-row>
      </tidy-card-button>
    </tidy-card>

    <!-- Balance + Quests skeleton -->
    <tidy-two-column-row>
      <tidy-card item-left>
        <tidy-card-button [hideArrow]="true">
          <tidy-row class="vertical-align-center">
            <ion-skeleton-text animated style="width: 18px; height: 18px; border-radius: 4px; margin-right: 5px"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
          </tidy-row>
          <tidy-row>
            <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
      <tidy-card item-right>
        <tidy-card-button [hideArrow]="true">
          <tidy-row class="vertical-align-center">
            <ion-skeleton-text animated style="width: 18px; height: 18px; border-radius: 4px; margin-right: 5px"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
          </tidy-row>
          <tidy-row>
            <ion-skeleton-text animated style="width: 55%"></ion-skeleton-text>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
    </tidy-two-column-row>

    <!-- Proposals + Invoices skeleton -->
    <tidy-two-column-row>
      <tidy-card item-left>
        <tidy-card-button [hideArrow]="true">
          <tidy-row class="vertical-align-center">
            <ion-skeleton-text animated style="width: 18px; height: 18px; border-radius: 4px; margin-right: 5px"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 45%"></ion-skeleton-text>
          </tidy-row>
          <tidy-row>
            <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
      <tidy-card item-right>
        <tidy-card-button [hideArrow]="true">
          <tidy-row class="vertical-align-center">
            <ion-skeleton-text animated style="width: 18px; height: 18px; border-radius: 4px; margin-right: 5px"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
          </tidy-row>
          <tidy-row>
            <ion-skeleton-text animated style="width: 55%"></ion-skeleton-text>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
    </tidy-two-column-row>

    <!-- Scores skeleton -->
    <tidy-card>
      <tidy-card-button [hideArrow]="true">
        <tidy-row class="vertical-align-center">
          <ion-skeleton-text animated style="width: 18px; height: 18px; border-radius: 4px; margin-right: 5px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
        </tidy-row>
        <tidy-row>
          <tidy-grid class="vertical-align">
            <ion-row>
              <ion-col size="5">
                <ion-skeleton-text animated style="width: 55%"></ion-skeleton-text>
              </ion-col>
              <ion-col size="7">
                <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="5">
                <ion-skeleton-text animated style="width: 65%"></ion-skeleton-text>
              </ion-col>
              <ion-col size="7">
                <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="5">
                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
              </ion-col>
              <ion-col size="7">
                <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-row>
      </tidy-card-button>
    </tidy-card>

    <!-- Notifications header skeleton -->
    <tidy-row>
      <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
    </tidy-row>
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>

<tidy-bottom-nav activeRoute="/dashboard">
</tidy-bottom-nav>